import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function App() {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [pdfInfo, setPdfInfo] = useState(null);
  const [messages, setMessages] = useState([]);
  const [question, setQuestion] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setFile(selectedFile);
    } else {
      alert('Please select a PDF file');
    }
  };

  const handleUpload = async () => {
    if (!file) {
      alert('Please select a file first');
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(`${API_URL}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setPdfInfo(response.data);
      setMessages([{
        type: 'system',
        text: `PDF uploaded! ${response.data.pages} pages, ${response.data.chunks} chunks created.`
      }]);
    } catch (error) {
      alert('Error uploading PDF: ' + (error.response?.data?.error || error.message));
    } finally {
      setUploading(false);
    }
  };

  const handleAsk = async (e) => {
    e.preventDefault();
    if (!question.trim() || !pdfInfo) return;

    const userMessage = { type: 'user', text: question };
    setMessages(prev => [...prev, userMessage]);
    setQuestion('');
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/query`, { question });
      const botMessage = {
        type: 'bot',
        text: response.data.answer,
        pages: response.data.pages
      };
      setMessages(prev => [...prev, botMessage]);
    } catch (error) {
      const errorMessage = {
        type: 'error',
        text: 'Error: ' + (error.response?.data?.error || error.message)
      };
      setMessages(prev => [...prev, errorMessage]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <div className="container">
        <h1>📄 PDF RAG Chatbot</h1>
        
        <div className="upload-section">
          <input
            type="file"
            accept=".pdf"
            onChange={handleFileChange}
            id="file-input"
            className="file-input"
          />
          <label htmlFor="file-input" className="file-label">
            {file ? file.name : 'Choose PDF file'}
          </label>
          <button
            onClick={handleUpload}
            disabled={!file || uploading}
            className="upload-btn"
          >
            {uploading ? 'Uploading...' : 'Upload & Process'}
          </button>
        </div>

        {pdfInfo && (
          <div className="pdf-info">
            ✓ {pdfInfo.filename} - {pdfInfo.pages} pages, {pdfInfo.chunks} chunks
          </div>
        )}

        <div className="chat-container">
          <div className="messages">
            {messages.length === 0 && !pdfInfo && (
              <div className="empty-state">
                Upload a PDF to start chatting
              </div>
            )}
            {messages.map((msg, idx) => (
              <div key={idx} className={`message ${msg.type}`}>
                <div className="message-content">
                  {msg.text}
                  {msg.pages && (
                    <div className="pages-info">
                      📖 Pages: {msg.pages.join(', ')}
                    </div>
                  )}
                </div>
              </div>
            ))}
            {loading && (
              <div className="message bot">
                <div className="message-content typing">Thinking...</div>
              </div>
            )}
          </div>

          {pdfInfo && (
            <form onSubmit={handleAsk} className="input-form">
              <input
                type="text"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                placeholder="Ask a question about your PDF..."
                disabled={loading}
                className="question-input"
              />
              <button type="submit" disabled={loading || !question.trim()} className="send-btn">
                Send
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
